import { PropsWithChildren } from 'react'
import { useModalLayout } from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalLayoutProvider'
import { Portal } from 'components/Portal/Portal'

export const ModalBackContainer = ({ children }: PropsWithChildren) => {
  const { backContainer } = useModalLayout()

  return <Portal container={backContainer}>{children}</Portal>
}
